module.exports = __webpack_public_path__ + "img/bnshow2.5f028b44.jpg";